import type { ReservationSlotGenerationResult } from '../../domain/reservationSlots';
import type {
  ReservationSlotRepository,
  GenerateReservationSlotsInput,
} from './ports/ReservationSlotRepository';

/**
 * 解放枠を一括生成するUseCase
 *
 * @description
 * 指定した年月・割り当てに基づき解放枠を生成する。
 * 同一月の既存枠はバックエンド側で洗い替え（削除→再作成）される。
 *
 * @param {ReservationSlotRepository} repository - Repository実装（DI）
 * @param {GenerateReservationSlotsInput} input - 入力データ
 * @returns {Promise<ReservationSlotGenerationResult>} 生成結果
 */
export async function generateReservationSlots(
  repository: ReservationSlotRepository,
  input: GenerateReservationSlotsInput
): Promise<ReservationSlotGenerationResult> {
  return repository.generate(input);
}
